import React, { useEffect } from 'react';
import type { ScrollAction } from './local-config-context';
import { LocalConfigContext } from './local-config-context';
import type { Theme } from '../theme-context/theme-context';

const themeKey = 'theme';
const scrollActionKey = 'scroll_action';
const githubRepoOpenedKey = 'github_repo_opened';
const starUsDialogLastOpenKey = 'star_us_dialog_last_open';

export const LocalConfigProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [theme, setTheme] = React.useState<Theme>(
    (localStorage.getItem(themeKey) as Theme) || 'system'
  );

  const [scrollAction, setScrollAction] = React.useState<ScrollAction>(
    (localStorage.getItem(scrollActionKey) as ScrollAction) || 'pan'
  );

  const [githubRepoOpened, setGithubRepoOpened] = React.useState<boolean>(
    (localStorage.getItem(githubRepoOpenedKey) || 'false') === 'true'
  );

  const [starUsDialogLastOpen, setStarUsDialogLastOpen] =
    React.useState<number>(
      parseInt(localStorage.getItem(starUsDialogLastOpenKey) || '0')
    );

  useEffect(() => {
    localStorage.setItem(
      starUsDialogLastOpenKey,
      starUsDialogLastOpen.toString()
    );
  }, [starUsDialogLastOpen]);

  useEffect(() => {
    localStorage.setItem(githubRepoOpenedKey, githubRepoOpened.toString());
  }, [githubRepoOpened]);

  useEffect(() => {
    localStorage.setItem(themeKey, theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem(scrollActionKey, scrollAction);
  }, [scrollAction]);

  return (
    <LocalConfigContext.Provider
      value={{
        theme,
        setTheme,
        scrollAction,
        setScrollAction,
        setGithubRepoOpened,
        githubRepoOpened,
        starUsDialogLastOpen,
        setStarUsDialogLastOpen,
      }}
    >
      {children}
    </LocalConfigContext.Provider>
  );
};
